import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=27560118&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=ts"
export * from "./MainFooter.vue?vue&type=script&lang=ts"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=27560118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27560118",
  null
  
)

export default component.exports